export default __webpack_public_path__ + "static/media/Evento_2.f4c08b16.jpg";